import {
  convertEventSelectToTarget,
  formatDataToLabelValue,
  FormFeedBack,
  Select,
} from '@repo/ui';
import { FormikProps } from 'formik';
import { useEffect } from 'react';
import { Col, Label } from 'reactstrap';

import { useProfessionalsLists } from '../../hooks/useProfessionalsLists';

interface IProps {
  validation: FormikProps<any>;
}

export const AssistantsOrAuxiliariesFilters = ({ validation }: IProps) => {
  // Hooks
  const {
    coursesUser,
    organizationsUser,
    getLegends,
    requestGetAllCoursesUser,
    requestGetAllOrganizationsUser,
  } = useProfessionalsLists();

  useEffect(() => {
    requestGetAllCoursesUser();
    requestGetAllOrganizationsUser();
  }, []);

  return (
    <>
      <Col lg={6} className="mb-3">
        <Label htmlFor="entity" className="form-label">
          {`${getLegends('ORGANIZACAO', false)}:`}
        </Label>
        <Select
          isClearable
          id="entity"
          name="entity"
          placeholder={`Todas as ${getLegends('ORGANIZACAO', true)}`}
          value={validation.values.entity}
          onChange={(e) => {
            requestGetAllCoursesUser(e?.value || '');
            validation.setValues({
              ...validation.values,
              course: null,
            });

            validation.handleChange(convertEventSelectToTarget('entity', e));
          }}
          invalid={!!(validation.touched && validation.errors?.entity)}
          onBlur={validation.handleBlur}
          options={formatDataToLabelValue(
            organizationsUser as never,
            'id',
            'nome',
          )}
        />
        <FormFeedBack
          error={String(validation.errors?.entity)}
          isInvalid={!!(validation.touched && validation.errors?.entity)}
        />
      </Col>

      <Col lg={6} className="mb-3">
        <Label htmlFor="course" className="form-label">
          {`${getLegends('CURSO', false)}:`}
        </Label>
        <Select
          isClearable
          id="course"
          name="course"
          placeholder={`Todos os ${getLegends('CURSO', true)}`}
          value={validation.values.course}
          onChange={(e) => {
            validation.handleChange(convertEventSelectToTarget('course', e));
          }}
          onBlur={validation.handleBlur}
          options={formatDataToLabelValue(coursesUser as never, 'id', 'nome')}
        />
        <FormFeedBack
          error={String(validation.errors?.course)}
          isInvalid={!!(validation.touched && validation.errors?.course)}
        />
      </Col>
    </>
  );
};
